/**
 * Module: screens/flow/_labels
 * Role: Russian display labels for flow checkpoint kinds.
 *       Lookup by `checkpoint.kind` (stable enum from flows/*.yaml),
 *       NOT by per-flow `slug` (varies across templates).
 *
 *       Pattern: 1:1 copy of `screens/creator/_labels.ts` lookup+fallback.
 *       Fallback: unknown kind renders as raw string (visible TODO, no crash).
 *
 * SYMMETRIC LIMIT — sync with `kind:` values in:
 *   - flows/*.yaml (checkpoint kind field)
 *   - src/domains/flow_engine/models.py:131 (Checkpoint.kind: str)
 *   - miniapp/src/api/flow-types.ts:58 (Checkpoint.kind: string)
 *
 * Used by: InstructionScreen, PickupOverviewScreen, CartScreen,
 *          UgcOverviewScreen, UgcPhotoGridScreen, S04SuccessContinue.
 * Glossary: ai/glossary/flow_engine.md
 */

/** Returns the Russian label for a checkpoint kind. Falls back to the raw value
 *  so a backend-added kind still renders (just untranslated, surfacing the
 *  drift as a visible TODO rather than crashing). */
function lookup(map: Record<string, string>, value: string): string {
  return map[value] ?? value;
}

// 19 checkpoint kinds as of 2026-06-08, extracted from flows/*.yaml:
//   wb-standard.yaml, pantene-format-a.yaml, pantene-format-b.yaml,
//   pantene-format-a-ozon.yaml, cart-only.yaml, reco-shelf.yaml
const KIND_LABELS: Record<string, string> = {
  WAIT: 'Ожидание доставки',
  ORDER: 'Оформление заказа',
  PICKUP: 'Получение товара',
  PICKUP_DELIVERED: 'Статус доставки',
  PICKUP_LABEL_PHOTO: 'Фото этикетки',
  PICKUP_TORN_PACKAGE: 'Вскрытие упаковки',
  RECEIPT: 'Чек',
  UGC: 'Отзыв',
  UGC_TEXT: 'Текст отзыва',
  UGC_PHOTO: 'Фото для отзыва',
  UGC_PUBLISHED: 'Публикация отзыва',
  SEARCH: 'Поиск товара',
  PHOTO: 'Фото',
  CART: 'Корзина',
  VIDEO_UPLOAD: 'Загрузка видео',
  PUBLISH: 'Публикация',
  MODERATION: 'Модерация',
  PAYMENT: 'Оплата',
  BRIEF: 'Бриф кампании',
  DONE: 'Готово',
};

export const flowStepLabel = (value: string): string => lookup(KIND_LABELS, value);
